<template>
    <div class="relative flex justify-center w-full">
        <div
            class="relative w-full max-w-md bg-white border-2 border-pink hover:border-green rounded cursor-pointer hover:shadow-lg px-6 py-8 transition hover:-translate-y-2"
            @click="openDoor()"
        >
            <div class="relative mt-1 text-sm leading-none tracking-wider uppercase">
                {{ selectedTitle }}
            </div>
        </div>

        <!-- :: Drop-Down Menu
        {+} ---------------------------------- -->
        <div
            class="absolute top-0 left-0 right-0 w-full max-w-md h-144 opacity-0 invisible -mt-8 mx-auto z-10"
            ref="dropDown"
        >
            <div class="absolute top-0 left-0 w-full bg-white shadow-lg" ref="dropDownBG"></div>

            <ul class="relative w-full h-full overflow-y-scroll opacity-0" ref="dropDownContent">
                <slot></slot>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title'],
    data() {
        return {
            selectedTitle: this.title,
            processing: false,
        }
    },
    methods: {
        /* :: Open Door
        {+} ---------------------------------- */
        openDoor() {
            const openDropDown = new TimelineMax()

            $(this.$refs.dropDown).removeClass('opacity-0 invisible')

            openDropDown
                .to(this.$refs.dropDownBG, 0.48, {
                    height: '100%',
                    ease: Circ.easeInOut,
                })
                .to(this.$refs.dropDownContent, 0.48, {
                    opacity: 1,
                    onComplete: () => {
                        document.addEventListener('click', this.closeDoor)
                    },
                })
        },

        /* :: Close Door
        {+} ---------------------------------- */
        closeDoor() {
            document.removeEventListener('click', this.closeDoor)

            const closeDropDown = new TimelineMax()
            this.processing = true

            closeDropDown
                .to(this.$refs.dropDownContent, 0.32, {
                    opacity: 0,
                })
                .to(this.$refs.dropDownBG, 0.32, {
                    height: '0%',
                    delay: -0.16,
                    ease: Circ.easeInOut,
                    onComplete: () => {
                        $(this.$refs.dropDown).addClass('opacity-0 invisible')

                        setTimeout(() => {
                            this.processing = false
                        }, 1000)
                    },
                })
        },
    },
}
</script>
